import axios from "@/plugins/axios";
// import * as example from "./example";

let url = "/api/v1/me/clover/logs";

export const logs = {
    // ...example,
    gets(data){
        return axios.get(url, data).then(result => result.data);
    }
}
